import React from 'react'
import { Platform } from 'react-native'

import LightningIcon from 'app/assets/icons/lightning.svg'
import Box from 'app/components/base/Box'
import LinearGradientBorderContainer from 'app/components/base/LinearGradientBorderContainer'
import Stack, { StackProps } from 'app/components/base/Stack'
import Text from 'app/components/base/Text'

export interface HintProps {
  title?: string
  icon?: React.ReactNode
  children?: React.ReactNode
  sx?: StackProps['sx']
  bodySx?: StackProps['sx']
  titleSx?: StackProps['sx']
  withGradientBackground?: boolean
  gradientBackgroundContentSx?: StackProps['sx']
  dataTestId?: string
  contentSx?: StackProps['sx']
}

const Hint: RFC<HintProps> = ({
  title,
  icon,
  sx,
  bodySx,
  titleSx,
  withGradientBackground = false,
  gradientBackgroundContentSx,
  dataTestId,
  contentSx,
  children
}) => {
  const hintContent = (
    <>
      <Box sx={{ width: 24, height: 24 }}>
        {!!icon ? icon : <LightningIcon />}
      </Box>

      <Stack
        direction="column"
        spacing={1}
        sx={{
          ...Platform.select({
            native: {
              pr: 5
            }
          }),
          ...bodySx
        }}
      >
        {title && (
          <Text variant="body2" sx={{ fontWeight: 500, ...titleSx }}>
            {title}
          </Text>
        )}

        <>{children}</>
      </Stack>
    </>
  )

  return (
    <LinearGradientBorderContainer
      {...(!withGradientBackground && { spacing: 1, direction: 'row' })}
      sx={{ ...sx }}
      sxContent={{
        ...Platform.select({
          web: {
            alignItems: { xs: 'flex-start', md: 'center' }
          },
          native: {
            alignItems: 'flex-start'
          }
        }),
        ...(withGradientBackground && {
          p: 0
        }),
        ...contentSx
      }}
      {...(!withGradientBackground && { dataTestId })}
    >
      {withGradientBackground ? (
        <LinearGradientBorderContainer
          borderWidth="0px"
          borderRadius={0}
          spacing={1}
          direction="row"
          startColor="rgba(23, 211, 255, 0.1)"
          lastColor="rgba(0, 234, 144, 0.1)"
          sx={{
            border: 'none',
            ...Platform.select({
              web: {
                background:
                  'linear-gradient(90deg, rgba(23, 211, 255, 0.1) 0%, rgba(0, 234, 144, 0.1) 100%)'
              }
            })
          }}
          sxContent={{
            backgroundColor: 'transparent',
            ...gradientBackgroundContentSx
          }}
          dataTestId={dataTestId}
        >
          {hintContent}
        </LinearGradientBorderContainer>
      ) : (
        hintContent
      )}
    </LinearGradientBorderContainer>
  )
}

export default Hint
